// extracted by mini-css-extract-plugin
export var box = "T_yg";
export var btnBase = "T_d1";
export var boxBtn = "T_yh T_d1";
export var btnWrapper = "T_d2";
export var closeBtn = "T_yj T_d1";
export var boxIcon = "T_yk";